import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { faTruckFast } from '@fortawesome/pro-solid-svg-icons/faTruckFast';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';

import style from './label-card.module.less';

const trackingStatusToIconMap = {
  Shipped: faTruckFast,
  Delivered: faCheck,
  DeliveryError: faExclamationTriangle,
};

const trackingStatusToClassNameMap = {
  Shipped: style['tracking-icon-shipped'],
  Delivered: style['tracking-icon-delivered'],
  DeliveryError: style['tracking-icon-error'],
};

/**
 * @param {object} props
 * @param {string} [props.status] - Tracking status (Shipped, Delivered, DeliveryError)
 * @param {boolean} [props.isExternal] - Whether this is external tracking
 * @returns {JSX.Element | null}
 */
const TrackingStatus = ({ status = null, isExternal = false }) => {
  if (!status || isExternal) {
    return null;
  }

  const icon = trackingStatusToIconMap[status] || faCircleQuestion;
  const iconStyle = trackingStatusToClassNameMap[status] || style['tracking-icon-unknown'];

  return (
    <div className={style['tracking-icon-container']} data-testid='tracking-status'>
      <FontAwesomeIcon className={iconStyle} icon={icon} />
    </div>
  );
};

export default TrackingStatus;
